import { AboutHero } from '../components/sections/AboutHero';
import { AboutValues } from '../components/sections/AboutValues';
import { AboutTimeline } from '../components/sections/AboutTimeline';
import { AboutPress } from '../components/sections/AboutPress';
import { AboutLeadership } from '../components/sections/AboutLeadership';
import { AboutStats } from '../components/sections/AboutStats';

const About = () => (
  <div>
    <AboutHero />
    <AboutValues />
    <AboutTimeline />
    <AboutPress />
    <AboutLeadership />
    <AboutStats />
  </div>
);

export default About;
